import styled from "styled-components";
import { COLORS, SIZES } from "../../layout/theme";

export const Inner = styled.div`
  flex: 1;
  flex-direction: row !important;
`;
